import React from "react"
import { observer } from "mobx-react-lite"
import styled from "~/ui/styled"
import useNavigation from "~hooks/useNavigation"
import { useStores } from "~models"
import { useActiveChat } from "~hooks/useActiveChat"
import { useChatList } from "~hooks/useChatList"
import { MessageTypes, CardType } from "~proto"
import { ChatHeaderLeft, ChatHeaderCenter } from "./chat-title"
import {
  HeaderAvatarButton,
  HeaderIconButton,
  HeaderSettingIconButton,
} from "~hooks/useMorePageEffect"

const Bar = styled.header`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 48px;
  padding: 0 8px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`

const Side = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
`

const SideRight = styled(Side)`
  justify-content: flex-end;
`

const Center = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  min-width: 0;
`

const RightActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

const ChatHeaderBar: React.FC = observer(function ChatHeaderBar() {
  const navigation = useNavigation()
  const { userStore, messageStore, apiStore } = useStores()
  const { chat: current, chatId } = useActiveChat()
  const { openShareCard } = useChatList(current)

  if (!current || !chatId) return null

  const openProfile = () => {
    if (current.chatTypeEnum === "GROUP") {
      navigation.navigate("GroupChatInformation", { chat_id: chatId })
    } else if (current.chatTypeEnum === "CHANNEL") {
      navigation.navigate("ChannelChatInformation", { chat_id: chatId })
    } else {
      navigation.navigate("PersonalCard", {
        userId: current.receiver.id,
        isSendMessageButtonVisible: false,
      })
    }
  }

  return (
    <Bar>
      <Side>
        <ChatHeaderLeft />
      </Side>
      <Center>
        <ChatHeaderCenter onClick={openProfile} />
      </Center>
      <SideRight>
        <RightActions>
          {["GROUP"].includes(current.chatTypeEnum) &&
            (current.isCurrentUserIsAdmin || current.isCurrentUserIsManager) && (
              <HeaderIconButton
                onClick={() => navigation.navigate("GroupChatManagement", { chat_id: chatId })}
              />
            )}
          {current.chatTypeEnum === "CHANNEL" && (
            <HeaderSettingIconButton
              chat={current}
              onClick={() => navigation.navigate("ChannelChatManagement", { chat_id: chatId })}
              onSharePress={() =>
                openShareCard({
                  title: "分享频道",
                  confirmText: "分享",
                  onConfirm: (contacts = []) => {
                    const senderId = userStore?.currentUser?.id
                    const shareUserId = current.id
                    const shareChatId = current.chat_id
                    const content = current.title || current.displayTitle || ""
                    if (!senderId) return

                    contacts.forEach((contact) => {
                      const targetId = contact?.user_id
                      if (!targetId) return
                      apiStore.getChatRoomId({ username: contact?.user?.username }).then((res) => {
                        const cardAttach = {
                          card_info: {
                            id: shareUserId,
                            chat_cid: shareChatId,
                            type: CardType[current?.chatTypeEnum],
                            sender_id: senderId,
                          },
                        }
                        if (res?.data?.id && res?.data?.chat_id) {
                          const mChat = chatStore.getChat(res?.data?.chat_id)
                          const m = mChat.newMessage({
                            type: MessageTypes.SHARE_CARD,
                            content,
                            attach: cardAttach,
                          })
                          messageStore.sendMessageByMessageType(m)
                        } else {
                          const newChat = chatStore.newPrivateChat({
                            receiver_id: targetId,
                            name: contact?.user?.name || contact?.displayName,
                          })
                          const m = newChat.newMessage({
                            type: MessageTypes.SHARE_CARD,
                            content,
                            attach: cardAttach,
                          })
                          messageStore.sendMessageByMessageType(m)
                        }
                      })
                    })
                  },
                })
              }
            />
          )}
          <HeaderAvatarButton chat={current} onClick={openProfile} />
        </RightActions>
      </SideRight>
    </Bar>
  )
})

export default ChatHeaderBar
